
<div class="row">
  <div class="col-xs-12">
    <form [formGroup]="eventForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
        <label for="uuid">Please Enter Your Event ID:</label>
        <input
        type="text"
        id="uuid"
        formControlName="uuid"
        class="form-control">
        <br>
        <button class="btn btn-primary" type="submit">Submit</button>
      </div>
    </form>
  </div>
</div>


<hr>

<div class="row">
      <div

        *ngFor="let chart of (chartState | async).charts; let i = index">
        <!--
        style="margin: 10px 10px 10px 10px; padding: 15px; border: 2px solid #f2f2f2;"
          -->


        <!--
        <p>{{ chart.chartType }}</p>
        <p>{{ chart.data }}</p>
        <p>{{ chart.labels }}</p>
        -->
        <div [ngSwitch]="chart.chartType">



            <app-bar-chart [barChartData]="chart.data" [barChartLabels]="chart.labels" *ngSwitchCase="'bar'"></app-bar-chart>
            <app-line-chart [lineChartData]="chart.data" [lineChartLabels]="chart.labels" *ngSwitchCase="'line'"></app-line-chart>
            <app-doughnut-chart [doughnutChartData]="chart.data" [doughnutChartLabels]="chart.labels" *ngSwitchCase="'doughnut'"></app-doughnut-chart>
            <app-pie-chart [pieChartData]="chart.data" [pieChartLabels]="chart.labels" *ngSwitchCase="'pie'"></app-pie-chart>
            <app-radar-chart [radarChartData]="chart.data" [radarChartLabels]="chart.labels" *ngSwitchCase="'radar'"></app-radar-chart>
            <app-polar-area-chart [polarAreaChartData]="chart.data" [polarAreaChartLabels]="chart.labels" *ngSwitchCase="'polarArea'"></app-polar-area-chart>
            <app-box-plot-chart [data]="chart.data" *ngSwitchCase="'boxPlot'"></app-box-plot-chart>
            <app-line-chart-with-table [lineChartData]="chart.data" [lineChartLabels]="chart.labels" *ngSwitchCase="'lineTable'"></app-line-chart-with-table>
          </div>

          </div>
        </div>





// WEBPACK FOOTER //
// ./src/app/report/report.component.html